// Utilidades de fechas para el calendario de áreas comunes. Sin librería
// externa (date-fns/dayjs) para no agregar otra dependencia — el manejo
// de fechas que necesita este calendario es simple.

export const HOURS = Array.from({ length: 15 }, (_, i) => 7 + i); // 07:00 a 21:00

export const toISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const startOfWeek = (d) => {
  const date = new Date(d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day; // lunes como inicio
  date.setDate(date.getDate() + diff);
  date.setHours(0, 0, 0, 0);
  return date;
};

export function monthMatrix(anchorDate) {
  const first = startOfMonth(anchorDate);
  const gridStart = startOfWeek(first);
  const weeks = [];
  let cursor = new Date(gridStart);
  for (let w = 0; w < 6; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      week.push(new Date(cursor));
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(week);
    if (cursor.getMonth() !== anchorDate.getMonth() && w >= 3) break; // no agregar semanas extra vacías
  }
  return weeks;
}

export function weekDays(anchorDate) {
  const start = startOfWeek(anchorDate);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    return d;
  });
}

export const WEEKDAY_LABELS = {
  es: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
  en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
};

export const MONTH_LABELS = {
  es: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
};

export const sameDay = (a, b) => toISODate(a) === toISODate(b);

/** Checa si dos rangos [aStart,aEnd) y [bStart,bEnd) (en horas, ej. 9 y 11) se cruzan. */
export const rangesOverlap = (aStart, aEnd, bStart, bEnd) => aStart < bEnd && bStart < aEnd;
